const mutations = {
  'SET_TECHNICIANS' (state, value) {
    state.technicians = value
  }
}

export default mutations
